import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import LoadingIndicator from 'components/LoadingIndicator';
import { withStyles } from '@material-ui/core/styles';
import _has from 'lodash/has';
import { gql, useQuery } from '@apollo/client';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import Grid from '@material-ui/core/Grid';
const styles = theme => ({
  logo: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    [theme.breakpoints.down('480')]: {
      margin: '20px 0',
    },
  },
  root: {
    [theme.breakpoints.down('480')]: {
      flexDirection: 'column !important',
    },
  },
  imgWrapper: {
    height: 120,
    padding: 12,
    border: '1px solid #E9ECED',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const GET_SPONSOR_LOGO = gql`
  {
    clientCollection(where: { sponsor: true }) {
      items {
        greyscaleLogo {
          url
        }
        colorLogo {
          url
        }
        shortName
        slug
      }
    }
  }
`;

function SponsorItems(props) {
  const { classes, onClick } = props;
  const { data } = useQuery(GET_SPONSOR_LOGO);
  if (_isEmpty(_get(data, 'clientCollection.items'))) {
    return <LoadingIndicator />;
  }

  return (
    <Grid container className={classes.root} spacing={2}>
      {data.clientCollection.items.map(item => {
        let url;
        if (_has(item.colorLogo, 'url')) ({ url } = item.colorLogo);
        else if (_has(item.greyscaleLogo, 'url'))
          ({ url } = item.greyscaleLogo);
        return (
          <Grid item xs={12} sm={6} key={item.slug}>
            <Link
              to={`company/sponsors/${item.slug}`}
              onClick={() => onClick(item)}
              className={classes.imgWrapper}
            >
              <img src={url} alt="Sponsor Logo" className={classes.logo} />
            </Link>
          </Grid>
        );
      })}
    </Grid>
  );
}

SponsorItems.propTypes = {
  classes: PropTypes.object,
  onClick: PropTypes.func,
};

export default withStyles(styles)(SponsorItems);
